import { OrderType } from '../order/types'
import { Security } from '../securities/reducer'
import { CheckedOrder } from './types'

export const checkOrder = (securityId: Security['id'], orderType: OrderType) =>
  ({
    type: 'checkedOrders.checkOrder',
    payload: { securityId, orderType }
  } as const)
export type CheckOrderAction = ReturnType<typeof checkOrder>

export const checkOrders = (checkedOrders: CheckedOrder[]) =>
  ({ type: 'checkedOrders.checkOrders', payload: checkedOrders } as const)
export type CheckOrdersAction = ReturnType<typeof checkOrders>

export const uncheckOrder = (
  securityId: Security['id'],
  orderType: OrderType
) =>
  ({
    type: 'checkedOrders.uncheckOrder',
    payload: { securityId, orderType }
  } as const)
export type UncheckOrderAction = ReturnType<typeof uncheckOrder>

export const uncheckOrders = (checkedOrders: CheckedOrder[]) =>
  ({ type: 'checkedOrders.uncheckOrders', payload: checkedOrders } as const)
export type UncheckOrdersAction = ReturnType<typeof uncheckOrders>

export const toggleOrder = (securityId: Security['id'], orderType: OrderType) =>
  ({
    type: 'checkedOrders.toggleOrder',
    payload: { securityId, orderType }
  } as const)
export type ToggleOrderAction = ReturnType<typeof toggleOrder>

export const resetCheckedOrders = () =>
  ({ type: 'checkedOrders.reset' } as const)
export type ResetCheckedOrdersAction = ReturnType<typeof resetCheckedOrders>

export const checkOrUncheckAll = (gridIndex: number, orderType: OrderType) =>
  ({
    type: 'checkedOrders.checkOrUncheckAllAction',
    payload: { gridIndex, orderType }
  } as const)
export type CheckOrUncheckAllAction = ReturnType<typeof checkOrUncheckAll>

export const updateCheckedOrders = (
  orderType: OrderType,
  securityIds: Array<Security['id']>
) =>
  ({
    type: 'checkedOrders.updateCheckedOrders',
    payload: { orderType, securityIds }
  } as const)
export type UpdateCheckedOrdersAction = ReturnType<typeof updateCheckedOrders>

export const cancelCheckedOrders = (updateStagedOrder: boolean = true) =>
  ({
    type: 'checkedOrders.cancelCheckedOrders',
    payload: { updateStagedOrder }
  } as const)
export type CancelCheckedOrdersAction = ReturnType<typeof cancelCheckedOrders>

export const submitCheckedOrders = () =>
  ({ type: 'checkedOrders.submitCheckedOrders' } as const)
export type SubmitCheckedOrdersAction = ReturnType<typeof submitCheckedOrders>

export const createTempCheckedOrders = (
  gridIndex: number,
  checkedOrders: CheckedOrder[]
) =>
  ({
    type: 'checkedOrders.createTempCheckedOrders',
    payload: { gridIndex, checkedOrders }
  } as const)
export type CreateTempCheckedOrders = ReturnType<typeof createTempCheckedOrders>

export const applyTempCheckedOrders = () =>
  ({ type: 'checkedOrders.applyTempCheckedOrders' } as const)
export type ApplyTempCheckedOrders = ReturnType<typeof applyTempCheckedOrders>

export type CheckedOrderAction =
  | CheckOrderAction
  | CheckOrdersAction
  | ToggleOrderAction
  | ResetCheckedOrdersAction
  | CheckOrUncheckAllAction
  | UpdateCheckedOrdersAction
  | CancelCheckedOrdersAction
  | SubmitCheckedOrdersAction
  | UncheckOrderAction
  | UncheckOrdersAction
  | CreateTempCheckedOrders
  | ApplyTempCheckedOrders
